import { getMyBenefitDownloadUrl } from "@benefit-systems/shared/features/mybenefit-app-download";
import {
  MobilePlatform,
  getPlatformStoreName,
} from "@benefit-systems/shared/utils/platform";
import Bolt from "@mui/icons-material/Bolt";
import Lock from "@mui/icons-material/LockOutlined";
import Notifications from "@mui/icons-material/NotificationsNone";
import { FC } from "react";

import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";

import DownloadNative from "web/assets/images/download_native.png";
import DownloadNativeWebp from "web/assets/images/download_native.webp";

import canUseWebp from "web/utils/system/DOM/media/canUseWebp";

import classes from "./nativeAppDownloadModal.scss";

interface NativeAppDownloadModalProps {
  platform: NonNullable<MobilePlatform>;
  onStoreClick?: () => void;
  onRemindLater?: () => void;
}

const NativeAppDownloadModal: FC<NativeAppDownloadModalProps> = ({
  platform,
  onStoreClick,
  onRemindLater,
}) => {
  const webpStatus = canUseWebp();
  const mobileImage = webpStatus ? DownloadNativeWebp : DownloadNative;
  const storeName = getPlatformStoreName(platform);
  const storeUrl = getMyBenefitDownloadUrl(platform);

  const features = [
    { icon: Bolt, label: "Błyskawiczny dostęp do kodów" },
    { icon: Notifications, label: "Ważne powiadomienia push" },
    {
      icon: Lock,
      label: `Autoryzacja ${
        platform === "ios" ? "FaceID / TouchID" : "biometryczna"
      }`,
    },
  ];

  return (
    <div className={classes.root}>
      <img
        className={classes.img}
        alt="Pobierz aplikacje i korzystaj z Kafeterii szybciej"
        src={mobileImage}
      />

      <section className={classes.section}>
        <header className={classes.content}>
          <h2 className={classes.heading}>
            {__("Pobierz aplikację MyBenefit")}
          </h2>
          <p className={classes.description}>
            {__("i zyskaj dodatkowe funkcje:")}
          </p>
        </header>
        <ul className={classes.content}>
          {features.map(({ icon: Icon, label }) => (
            <li key={label} className={classes.featureItem}>
              <Icon className={classes.featureItemIcon} aria-hidden="true" />
              <span className={classes.featureItemLabel}>{__(label)}</span>
            </li>
          ))}
        </ul>
      </section>
      <div className={classes.section}>
        <Button
          className={classes.downloadButton}
          dataT1="download-app"
          to={storeUrl ?? "#"}
          variant="tertiary"
          target="_blank"
          ariaLabel={__(`Pobierz w ${storeName}`)}
          onClick={onStoreClick}
        >
          {__(`Pobierz w ${storeName}`)}
        </Button>
        <Button
          variant="text-button"
          dataT1="remind_later"
          onClick={onRemindLater}
        >
          {__("Kontynuuj w przeglądarce")}
        </Button>
      </div>
    </div>
  );
};

export default NativeAppDownloadModal;
